import users from './Users';
import password from './Password';

const API = {
  users,
  password,
};

export default API;
